module.exports = __webpack_public_path__ + "img/DE01043.67411871.png";